import { makeAutoObservable } from 'mobx'
import * as API from 'service/api/PolicyTemplateApi'
import table from '../common/table'
import { IInit } from 'models/Global.model'

class PolicyTemplateStore {
  constructor() {
    makeAutoObservable(this)
  }

  policyTemplateTable = new table(API.GET_POLICY_TEMPLATE_PAGE_LIST)

  init = (data: IInit) => {
    const {
      param = {},
      pageSize = 10,
      pageNo = 1,
      isPageNum = true,
      isResetParam = false
    } = data

    this.policyTemplateTable.init(param, isPageNum, isResetParam)
    this.policyTemplateTable.getList(pageNo, pageSize)
  }

  getPolicyTemplateInfo = async (id: string) => {
    return await API.GET_POLICY_TEMPLATE_INFO(id)
  }

  addPolicyTemplate = async (data: any) => {
    return await API.ADD_POLICY_TEMPLATE(data)
  }

  updatePolicyTemplate = async (data: any) => {
    return await API.UPDATE_POLICY_TEMPLATE(data)
  }

  delPolicyTemplate = async (id: string) => {
    return await API.DEL_POLICY_TEMPLATE(id)
  }
}

export default new PolicyTemplateStore()
